<template>
  <v-container grid-list-md class="pa-0 ma-0">
    <v-layout row wrap>
      <v-flex xs12 mx-auto v-if="lAction === 'view'">
        <!-- search the data based on date -->
        <v-card flat class="ma-2">
          <v-card-text class="pa-0">
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs12 sm4 class="pt-2 text-xs-left grey-lighten-4">
                  <span v-for="(chip, index) in chips" :key="index">
                    <v-chip small @click="loadDailyUpdateBasedOnPeriod(chip)" :class="enableChip === chip ? 'primary white--text' : ''">
                      {{chip}}
                    </v-chip>
                  </span>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-layout row wrap class="ml-2" v-if="enableChip === 'Specific Date'">
                    <v-flex xs10 class="text-sm-right">
                      <v-dialog ref="dlgDate"
                      persistent v-model="dlgDate"
                      lazy max-width="290px"
                      :return-value.sync="lDate">
                      <v-text-field
                      slot="activator" label="Date"
                      v-model="lDate" append-icon="event"
                      readonly clearable
                      hide-details
                      ></v-text-field>
                      <v-date-picker v-model="lDate"
                      first-day-of-week="1">
                      <v-spacer></v-spacer>
                      <v-btn flat @click="dlgDate = false">Cancel</v-btn>
                      <v-btn flat color="accent" @click="$refs.dlgDate.save(lDate)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex xs2 class="text-xs-left">
                  <v-btn small fab class="accent" @click.native="loadDailyAllUpdates(lDate)">Go</v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm4 class="text-xs-right">
              <v-btn v-if="lDailyUpdate && lDailyUpdate.is_sub_app === 0 && lDailyUpdate.is_app === 0" small @click="submitApproval">Submit for Approval</v-btn>
              <v-btn v-if="lDailyUpdate && lDailyUpdate.is_sub_app === 1 && lDailyUpdate.is_app === 0 && !config.ROLE_NAME.includes('Facility Manager') && !config.ROLE_NAME.includes('Helpdesk')" small @click="approveUpdate">Approve Daily Update</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-card-text>
    </v-card>

    <v-card flat class="ma-2" v-if="!lDailyUpdate.c_date">
      <v-card-text class="pa-0">
        <v-layout row wrap>
          <v-flex xs12>
            <div class="text-xs-center">
              <v-alert value="true" color="#4DA6A1">
                No data is available for choosen date. You may start entering it.
              </v-alert>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

    <!-- current status -->
    <v-card flat class="ma-2">
      <v-card-text class="pa-0">
        <v-layout row wrap>
          <v-flex xs12 v-if="lDailyUpdate && lDailyUpdate.is_sub_app === 0 && lDailyUpdate.is_app === 0">
            <div class="text-xs-center">
              <v-alert value="true" color="yellow" class="black--text pa-2">
                {{'Draft, not submitted for approval yet.' }} <br /><span class="caption"> {{'Updated by: ' + (lDailyUpdate.updated_by_name || ' Vendor FM ') + ' on ' + handy.formatDBDateTime(lDailyUpdate.updated_on)}}</span>
              </v-alert>
            </div>
          </v-flex>
          <v-flex xs12 v-if="lDailyUpdate && lDailyUpdate.is_sub_app && lDailyUpdate.is_app === 0">
            <div class="text-xs-center">
              <v-alert value="true" color="orange" class="pa-2">
                {{ 'Pending for Approval.'}}<br /><span class="caption">{{'Updated by: ' + (lDailyUpdate.updated_by_name || ' Vendor FM ') + ' on ' + handy.formatDBDateTime(lDailyUpdate.updated_on)}}</span>
              </v-alert>
            </div>
          </v-flex>
          <v-flex xs12 v-if="lDailyUpdate && lDailyUpdate.is_app">
            <div v-if="lDailyUpdate.app_by" class="text-xs-center">
              <v-alert value="true" color="success" class="pa-2">
                {{ 'Approved.' }} <br /><span class="caption">{{'By: ' + (lDailyUpdate.app_by_name || ' Vendor manager ') + ' on ' + handy.formatDBDateTime(lDailyUpdate.app_on) }} </span>
              </v-alert>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

    <!-- Enable the chip to compare the data with previous day -->
    <v-card-actions class="py-0">
      <v-chip @click="compareWithPreviousDay" :color="enablePreviousDay === true ? 'primary white--text' : ''">COMPARE WITH PREVIOUS DAY</v-chip>
      <v-spacer></v-spacer>
      <v-btn small class="ma-0" @click="showUploadImage = true"><v-icon class="pr-2">insert_photo</v-icon>{{ 'Photos (' + lDailyUpdateAttach.fileUrls.length + ')'}}</v-btn>
    </v-card-actions>

    <!-- Attendance -->
    <v-card class="ma-2">
      <v-card-title class="pt-0 pb-0 pl-2 pr-2 grey lighten-4">
        <div class="title grey--text">Attendance <br v-if="!$vuetify.breakpoint.smAndUp" /><span class="subheading">{{'[' + handy.formatDate(lDate)+ ']'}}</span></div>
        <v-spacer></v-spacer>
        <router-link :to="{ path: '/attendance/' }" style="text-decoration: none; color: black;">
          <v-btn flat class="pt-0 pb-0">go to Attendance</v-btn>
        </router-link>
      </v-card-title>
      <v-card-text class="pa-0 pr-1 pt-1">
        <v-layout row wrap>
          <v-flex xs4 sm2 class="mt-3 pr-0 pl-1">
            <v-card flat>
              <v-card-text class="pr-0">
                <span v-for="(avg, i) in lSummary">
                  <div class="display-1 text-lg-center">{{ avg.attAve ? avg.attAve + ' %' : '0 %' }}</div>
                </span>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs8 sm10 class="pa-0 ma-0">
            <v-data-table
            :headers="$vuetify.breakpoint.smAndUp?attendance:attendanceSm"
            :items="lSummary"
            hide-actions
            disable-initial-sort
            >
            <template slot="items" slot-scope="props">
              <tr @click="showAttendanceSummary(props.item.att_dt)" :class="lSummary.length > 1 && props.index === 0 ? 'blue lighten-4' : ''">
                <td>{{ props.item.tot_present }}</td>
                <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_wo }}</td>
                <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_holiday }}</td>
                <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_ot }}</td>
                <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_leave }}</td>
                <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_absent }}</td>
                <td class="red--text lighten-3 pa-2">{{ props.item.tot_pend }}</td>
                <td class="black--text lighten-3">{{ props.item.tot_staff }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
  <v-flex xs12 class="pa-2">
    <v-flex xs12 class="pt-2">
      <v-text-field
      v-model="lDailyUpdate.remark_attendance"
      label="Attendance Remark If Any"
      maxlength="150"
      hide-details
      @change="postObserv()"
      outline
      ></v-text-field>
    </v-flex>
  </v-flex>

  <!-- Water Quality -->
  <v-card class="ma-2">
    <v-card-title class="pa-2 grey lighten-4">
      <div class="title grey--text">Water Quality <br v-if="!$vuetify.breakpoint.smAndUp" /><span class="subheading">{{'[' + handy.formatDate(lDate) + ']'}}</span></div>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
      :headers="$vuetify.breakpoint.smAndUp ? (enablePreviousDay === true ? watQualDt : watQual) : watQualSm"
      :items="dailyQualList"
      hide-actions
      disable-initial-sort
      >
      <template slot="items" slot-scope="props">
        <tr @click="prepareEditWaterQual(props.item)" :class="props.item.c_date !== lDate ? 'blue lighten-4' : ''">
          <td>{{ props.item.water_type ? props.item.water_type : '-' }}</td>
          <td>{{ props.item.param_name ? props.item.param_name : '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ (props.item.std_val_min ? props.item.std_val_min:0) + ' to ' + props.item.std_val_max }}</td>
          <td :class="(props.item.val < props.item.std_val_min || props.item.val > props.item.std_val_max) && props.item.val !== null ? 'error white--text' : 'black--text'">{{ props.item.val ? props.item.val : '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp && enablePreviousDay === true">{{ props.item.c_date }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>

<!-- Water Management -->
<v-card class="ma-2">
  <v-card-title class="pa-2 grey lighten-4">
    <div class="title grey--text">Water Management <br v-if="!$vuetify.breakpoint.smAndUp" /><span class="subheading">{{'[' + handy.formatDate(lDate) + ']'}}</span></div>
  </v-card-title>
  <v-card-text class="pa-2">
    <v-layout row wrap>
      <!-- water sources -->
      <v-flex xs12>
        <v-card>
          <v-card-text class="py-2 px-0">
            <v-layout row wrap>
              <v-flex xs12>
                <span class="px-2 primary--text">Water Sources</span>
              </v-flex>
              <v-flex xs12>
                <v-data-table
                :headers="enablePreviousDay === true ? watTypeDt : watType"
                :items="domWatList"
                hide-actions
                disable-initial-sort
                >
                <template slot="items" slot-scope="props">
                  <tr @click="PreapreEditDomWatList(props.item)" :class="props.item.c_date !== lDate ? 'blue lighten-4' : ''">
                    <td>{{ props.item.water_type ? props.item.water_type : '-' }}</td>
                    <td>{{ props.item.water_receipt ? props.item.water_receipt : '-' }}</td>
                    <td v-if="enablePreviousDay === true">{{ props.item.c_date ? props.item.c_date : '-' }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
    <!-- water level & storage -->
    <v-flex xs12>
      <v-card>
        <v-card-text class="pa-0">
          <v-flex xs12 class="pb-1 pt-2 pl-2">
            <span class="primary--text">Water Level and Storage</span>
          </v-flex>
          <v-flex xs12 class="pa-0">
            <v-data-table
            :headers="enablePreviousDay === true ? watStorageDt : watStorage"
            :items="watList"
            hide-actions
            disable-initial-sort
            >
            <template slot="items" slot-scope="props">
              <tr @click="PreapreEditWatStorage(props.item)" :class="props.item.c_date !== lDate ? 'blue lighten-4' : ''">
                <td>{{ props.item.storage_nm ? props.item.storage_nm : '-' }}</td>
                <td>{{ props.item.water_cat }}</td>
                <td>{{ props.item.is_level_checked ? (props.item.water_level ? props.item.water_level : '-') : 'N/A' }}</td>
                <td class="px-2">{{ props.item.is_cons_checked ? (props.item.water_cons === null ? '-' : props.item.water_cons) : 'N/A' }}</td>
                <td v-if="enablePreviousDay === true">{{ props.item.c_date ? props.item.c_date : '-' }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-flex>
</v-layout>
</v-card-text>
</v-card>
<v-flex xs12 class="pa-2">
  <v-flex xs12 class="pt-2">
    <v-text-field
    v-model="lDailyUpdate.remark_water"
    label="Water Management Remark If Any"
    maxlength="150"
    hide-details
    @change="postObserv()"
    outline
    ></v-text-field>
  </v-flex>
</v-flex>

<!-- Power Consumption -->
<v-card class="ma-2">
  <v-card-title class="pa-2 grey lighten-4">
    <div v-if="$vuetify.breakpoint.smAndUp" class="title grey--text">Power Consumption <br v-if="!$vuetify.breakpoint.smAndUp" /><span class="subheading">{{'[' + handy.formatDate(lDate) + ']'}}</span></div>
    <div v-else class="title grey--text">Power <br v-if="!$vuetify.breakpoint.smAndUp" /><span class="subheading">{{'[' + handy.formatDate(lDate) + ']'}}</span></div>
  </v-card-title>
  <v-card-text class="pa-0">
    <v-data-table
    :headers="enablePreviousDay === true ? powerConsDt : powerCons"
    :items="powerList"
    no-data-text="Power consumption is not applicable for this site"
    hide-actions
    disable-initial-sort>
    <template slot="items" slot-scope="props">
      <tr @click="prepareEditCons(props.item)" :class="props.item.c_date !== lDate ? 'blue lighten-4' : ''">
        <td>{{ props.item.meter_nm ? props.item.meter_nm : '-' }}</td>
        <td>{{ props.item.units_cons ? props.item.units_cons : 0 }}</td>
        <td v-if="enablePreviousDay === true">{{ props.item.c_date ? props.item.c_date : '-' }}</td>
      </tr>
    </template>
  </v-data-table>
</v-card-text>
</v-card>

<!-- Genset Power Consumption, Diesel Level & Stock -->
<v-card class="ma-2">
  <v-card-title class="pa-2 grey lighten-4">
    <div v-if="$vuetify.breakpoint.smAndUp" class="title grey--text">Genset Power Consumption, Diesel Level &amp; Stock <br v-if="!$vuetify.breakpoint.smAndUp" /><span class="subheading">{{'[' + handy.formatDate(lDate) + ']'}}</span></div>
    <div v-else class="title grey--text">Genset <br v-if="!$vuetify.breakpoint.smAndUp" /><span class="subheading">{{'[' + handy.formatDate(lDate) + ']'}}</span></div>
  </v-card-title>
  <v-card-text class="pa-0">
    <v-data-table
    :headers="enablePreviousDay === true ? genPowerDt : genPower"
    :items="gensetList"
    hide-actions
    no-data-text="Genset is not applicable for this site"
    disable-initial-sort>
    <template slot="items" slot-scope="props">
      <tr @click="prepareEditGen(props.item)" :class="props.item.c_date !== lDate ? 'blue lighten-4' : ''">
        <td>{{ props.item.genset_nm ? props.item.genset_nm : '-' }}</td>
        <td>{{ props.item.units_cons ? props.item.units_cons : '-' }}</td>
        <td>{{ props.item.level ? props.item.level : '-' }}</td>
        <td>{{ props.item.purchased ? props.item.purchased : '-' }}</td>
        <td>{{ props.item.stock ? props.item.stock : '-' }}</td>
        <td>{{ props.item.run_hrs ? props.item.run_hrs : '-' }}</td>
        <td>{{ props.item.kwh_kva ? props.item.kwh_kva : '-' }}</td>
        <td v-if="enablePreviousDay === true">{{ props.item.c_date ? props.item.c_date : '-' }}</td>
      </tr>
    </template>
  </v-data-table>
</v-card-text>
</v-card>
<v-flex xs12 class="pa-2">
  <v-flex xs12 class="pt-2">
    <v-text-field
    v-model="lDailyUpdate.remark_power"
    label="Power Management Remark If Any"
    maxlength="150"
    hide-details
    @change="postObserv()"
    outline
    ></v-text-field>
  </v-flex>
</v-flex>

<!-- Waste Management -->
<v-card class="ma-2">
  <v-card-title class="pa-2 grey lighten-4">
    <div class="title grey--text">Waste Management <br v-if="!$vuetify.breakpoint.smAndUp" /><span class="subheading">{{'[' + handy.formatDate(lDate) + ']'}}</span></div>
  </v-card-title>
  <v-card-text class="pa-0">
    <v-data-table
    :headers="enablePreviousDay === true ? wasteManaDt : wasteMana"
    :items="lWasteList"
    hide-actions
    disable-initial-sort>
    <template slot="items" slot-scope="props">
      <tr @click="prepareEditWaste(props.item)" :class="props.item.c_date !== lDate ? 'blue lighten-4' : ''">
        <td>{{ props.item.waste_type ? props.item.waste_type : '-' }}</td>
        <td>{{ props.item.kgs ? props.item.kgs : 0 }}</td>
        <td v-if="enablePreviousDay === true">{{ handy.formatDBDate(props.item.c_date) }}</td>
      </tr>
    </template>
  </v-data-table>
</v-card-text>
</v-card>

<!-- Hygiene Management -->
<v-card class="ma-2" v-if="lSanCheck.length > 0">
  <v-card-title class="pa-2 grey lighten-4">
    <div class="title grey--text">Hygiene Management/Sanity Checks <br v-if="!$vuetify.breakpoint.smAndUp" /><span class="subheading">{{'[' + handy.formatDate(lDate) + ']'}}</span></div>
  </v-card-title>
  <v-card-text class="pa-0">
    <v-layout row wrap>
      <v-flex xs12 v-for="(cat, n) in lSanCheck" :key="n">
        <div class="pa-2 primary--text" v-if="cat.check_cat">{{ cat.check_cat }}</div>
        <v-flex xs12 class="pa-0">
          <v-data-table
          hide-headers
          :items="sanCheckList.filter(rec => rec.check_cat === cat.check_cat)"
          hide-actions>
          <template slot="items" slot-scope="props">
            <tr @click="prepareEditSanCheck(cat.check_cat)">
              <td class="pr-0" :style="$vuetify.breakpoint.smAndUp ? 'width: 300px;' : 'width: 150px;'">{{ props.item.check_desc ? props.item.check_desc : '-' }}</td>
              <td style="width: 50px;" class="pt-1 pr-0">
                <v-checkbox v-model="props.item.check_value" disabled hide-details></v-checkbox>
              </td>
              <td>Remarks: {{props.item.remark}}</td>
              <td v-if="enablePreviousDay === true">{{ handy.formatDBDate(props.item.c_date) }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-flex>
  </v-layout>
</v-card-text>
</v-card>
<v-flex xs12 class="pa-2" v-if="lSanCheck.length > 0">
  <v-flex xs12 class="pt-2">
    <v-text-field
    v-model="lDailyUpdate.remark_sanity_checks"
    label="Sanity Checks Remark If Any"
    maxlength="150"
    hide-details
    @change="postObserv()"
    outline
    ></v-text-field>
  </v-flex>
</v-flex>

<!-- Custom Metrics -->
<v-card class="ma-2" v-if="lMet.length > 0">
  <v-card-title class="pa-2 grey lighten-4">
    <div class="title grey--text">Custom Metrics <br v-if="!$vuetify.breakpoint.smAndUp" /><span class="subheading">{{'[' + handy.formatDate(lDate) + ']'}}</span></div>
  </v-card-title>
  <v-card-text class="pa-0">
    <v-layout row wrap>
      <v-flex xs12 v-for="(metric, n) in lMet" :key="n">
        <div class="pa-2 primary--text" v-if="metric">{{ metric.metric_cat }}</div>
        <v-flex xs12 class="pa-0">
          <v-data-table
          :headers="metHead"
          :items="metricList.filter(rec => rec.metric_cat === metric.metric_cat)"
          hide-actions>
          <template slot="items" slot-scope="props">
            <tr @click="prepareEditCusMet(props.item)">
              <td>{{ props.item.metric_nm ? props.item.metric_nm : '-' }}</td>
              <td>{{ props.item.metric_val ? props.item.metric_val : 0}}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-flex>
  </v-layout>
</v-card-text>
</v-card>
<v-flex xs12 class="pa-2" v-if="lMet.length > 0">
  <v-flex xs12 class="pt-2">
    <v-text-field
    v-model="lDailyUpdate.remark_custom_metrics"
    label="Custom Metrics Remark If Any"
    maxlength="150"
    hide-details
    @change="postObserv()"
    outline
    ></v-text-field>
  </v-flex>
</v-flex>

<!-- Major Observation -->
<v-card class="ma-2 mt-3">
  <v-card-title class="pa-2 grey lighten-4">
    <div class="title grey--text">Major Observation</div>
  </v-card-title>
  <v-card-text class="pa-2">
    <v-layout row wrap>
      <v-flex xs12 v-if="enablePreviousDay === true && dailyUpdatepreviousDayReport.c_date">
        <v-alert value="true" color="blue lighten-4" class="black--text">
          {{ handy.formatDBDate(dailyUpdatepreviousDayReport.c_date) + ': ' + (dailyUpdatepreviousDayReport.major_observ ? dailyUpdatepreviousDayReport.major_observ : 'NA') }}
        </v-alert>
      </v-flex>
      <v-flex xs12>
        <vue-editor
        v-model="lDailyUpdate.major_observ"
        placeholder="Major Observation Today If Any"
        :editorToolbar="handy.customToolbar"
        @input="limitChar(lDailyUpdate.major_observ)"
        ></vue-editor>
      </v-flex>
      <v-flex xs12>
        <div class="text-xs-right caption grey--text">
          {{ charLen + ' / ' + charLimit }}
        </div>
      </v-flex>
    </v-layout>
  </v-card-text>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn @click.native="postObserv()" class="accent">save</v-btn>
  </v-card-actions>
</v-card>
</v-flex>
</v-layout>

<v-btn :style="'position:fixed; top:55px; right:10px;'" dark fab small fixed
color="accent"
@click.native="showTimeline = true">
<v-icon>timeline</v-icon>
</v-btn>

<!-- Attendance summary -->
<v-dialog v-model="showSummary" persistent scrollable max-width="900px">
  <v-card>
    <v-card-title class="pa-2 grey lighten-4">
      <div class="title grey--text">Attendance Summary <br v-if="!$vuetify.breakpoint.smAndUp" /><span class="subheading">{{'[' + handy.formatDate(lDate) + ']'}}</span></div>
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="showSummary = false"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
      :headers="$vuetify.breakpoint.smAndUp ? repHeadSm : repHead"
      :items="attReport"
      hide-actions>
      <template slot="items" slot-scope="props">
        <tr>
          <td>{{ props.item.staff_role }}</td>
          <td class="pa-0">{{ props.item.tot_present }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_wo }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_holiday }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_ot }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_leave }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_absent }}</td>
          <td class="red--text pa-0">{{ props.item.tot_pend }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
</v-dialog>

<!-- Update Water Quality value -->
<v-dialog v-model="showWaterQual" persistent max-width="500px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="lForm" @submit.prevent="saveWatQualChanges()">
        <v-card scrollable>
          <v-card-title  class="title grey lighten-4">
            {{ lWatQual.water_type + ' ' + lWatQual.param_name }}
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-text-field
              v-model="lWatQual.val"
              label="Value"
              :rules="[rules.required]"
              hide-details
              maxlength="5"
              type = "number"
              ></v-text-field>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn flat @click.stop="showWaterQual = false">Cancel</v-btn>
            <v-btn flat type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<!-- Update Water Storage -->
<v-dialog v-model="showWatStorage" persistent max-width="500px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="sForm" @submit.prevent="saveWatStorageChanges()">
        <v-card scrollable>
          <v-card-title class="title grey lighten-4">
            {{ lWatStorage.storage_nm }}
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm6>
                <v-text-field
                v-model="lWatStorage.water_level"
                label="Water Level (%)"
                :disabled="lWatStorage.is_level_checked === 0"
                :placeholder="lWatStorage.is_level_checked ? '' : 'N/A'"
                hide-details
                maxlength="11"
                type = "number"
                ></v-text-field>
              </v-flex>
              <!--<v-flex xs12>
              <v-text-field
              v-model="lWatStorage.water_receipt"
              label="Water Receipt (KL)"
              hide-details
              maxlength="11"
              type = "number"
              :disabled="lWatStorage.is_receipt_checked === 0"
              :placeholder="lWatStorage.is_receipt_checked ? '' : 'N/A'"
              ></v-text-field>
            </v-flex> -->
            <v-flex xs12 sm6>
              <v-text-field
              v-model="lWatStorage.water_cons"
              label="Water Consumption (KL)"
              hide-details
              maxlength="11"
              type = "number"
              :disabled="lWatStorage.is_cons_checked === 0"
              :placeholder="lWatStorage.is_cons_checked ? '' : 'N/A'"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-spacer></v-spacer>
          <v-btn flat @click.stop="showWatStorage = false">Cancel</v-btn>
          <v-btn flat type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-flex>
</v-container>
</v-dialog>

<v-dialog v-model="showDomWat" persistent max-width="500px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="dForm" @submit.prevent="saveDomWatChanges()">
        <v-card scrollable>
          <v-card-title  class="title grey lighten-4">
            {{ lDomWat.water_type }}
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-text-field
              v-model="lDomWat.water_receipt"
              label="Water Receipt (KL)"
              :rules="[rules.required]"
              hide-details
              type="number"
              ></v-text-field>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn flat @click.stop="showDomWat = false">Cancel</v-btn>
            <v-btn flat type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<!-- Update Power Consumption -->
<v-dialog v-model="showPowerCons" persistent max-width="500px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="pForm" @submit.prevent="savePowerConsChanges()">
        <v-card scrollable>
          <v-card-title  class="title grey lighten-4">
            {{ lPower.meter_nm }}
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                v-model="lPower.units_cons"
                label="Units"
                :rules="[rules.required]"
                hide-details
                maxlength="11"
                type = "number"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn flat @click.stop="showPowerCons = false">Cancel</v-btn>
            <v-btn flat type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<!-- Update Power Genset -->
<v-dialog v-model="showPowerGen" persistent max-width="500px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="gForm" @submit.prevent="savePowerGenChanges()">
        <v-card scrollable>
          <v-card-title  class="title grey lighten-4">
            {{ lGenset.genset_nm }}
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 class="pa-0 pl-1">
                <span class="primary--text">Power</span>
              </v-flex>
              <v-flex xs12 class="pt-0">
                <v-text-field
                v-model="lGenset.units_cons"
                label="Units Generated"
                :rules="[rules.required]"
                hide-details
                maxlength="11"
                type = "number"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 class="pa-0 pt-3 pl-1">
                <span class="primary--text">Diesel</span>
              </v-flex>
              <v-flex xs12 class="pt-0">
                <v-text-field
                v-model="lGenset.level"
                label="Level (%)"
                :rules="[rules.required]"
                hide-details
                maxlength="5"
                type = "number"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model="lGenset.purchased"
                label="Purchased (ltr)"
                :rules="[rules.required]"
                hide-details
                maxlength="7"
                type = "number"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model="lGenset.stock"
                label="Stock (ltr)"
                :rules="[rules.required]"
                hide-details
                maxlength="7"
                type = "number"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model="lGenset.run_hrs"
                label="Running Hours"
                hide-details
                type = "number"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model="lGenset.kwh_kva"
                label="KWH/KVA"
                hide-details
                disabled
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn flat @click.stop="showPowerGen = false">Cancel</v-btn>
            <v-btn flat type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<!-- Update Waste Management -->
<v-dialog v-model="showWaste" persistent max-width="500px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="wForm" @submit.prevent="saveWasteChanges()">
        <v-card scrollable>
          <v-card-title  class="title grey lighten-4">
            {{ lWaste.waste_type + ' Waste' }}
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                v-model="lWaste.kgs"
                label="Kgs"
                :rules="[rules.required]"
                hide-details
                maxlength="5"
                type = "number"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn flat @click.stop="showWaste = false">Cancel</v-btn>
            <v-btn flat type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<!-- Update Custom Metric -->
<v-dialog v-model="showCusMet" persistent max-width="500px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="mForm" @submit.prevent="saveMetChanges()">
        <v-card scrollable>
          <v-card-title  class="title grey lighten-4">
            {{ lMetric.metric_nm }}
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                v-model="lMetric.metric_val"
                label="Value"
                :rules="[rules.required]"
                hide-details
                maxlength="5"
                type = "number"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn flat @click.stop="showCusMet = false">Cancel</v-btn>
            <v-btn flat type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<!-- Show Uploaded Images -->
<v-dialog v-model="showUploadImage" scrollable max-width="900px">
  <v-card>
    <v-card-title class="py-1 title grey lighten-4">
      <div>{{ 'Photos (' + handy.formatDate(lDate) + ')' }}</div>
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="showUploadImage = false"><v-icon>close</v-icon></v-btn>
      <v-flex xs12 class="pb-2">
        <span v-for="(chip, index) in photoCatChips" :key="index">
          <v-chip :style="$vuetify.breakpoint.smAndUp ? '' : 'width:30%;'" :color="lDailyUpdateAttach.cat === chip.attach_cat_id ? 'primary white--text' : ''" @click="loadCategoryImage(chip.attach_cat_id)">
            {{chip.attach_cat_name + (lDailyUpdateAttach.fileUrls ? (lDailyUpdateAttach.fileUrls && lDailyUpdateAttach.fileUrls.filter(rec => rec.attach_cat_id === chip.attach_cat_id).length ? (' (' + lDailyUpdateAttach.fileUrls.filter(rec => rec.attach_cat_id === chip.attach_cat_id).length + ')') : '') : '') }}</v-chip>
          </span>
          <v-chip :color="lDailyUpdateAttach.cat === 'All' ? 'primary white--text' : ''" @click="loadCategoryImage('All')">All ({{lDailyUpdateAttach.fileUrls && lDailyUpdateAttach.fileUrls.length}})</v-chip>
          <v-chip :color="lDailyUpdateAttach.cat === 'Online' ? 'primary white--text' : ''" @click="loadCategoryImage('Online')">Online ({{ lDailyUpdateAttach.fileUrls && lDailyUpdateAttach.fileUrls.filter(rec => !rec.operation).length }})</v-chip>
          <v-chip :color="lDailyUpdateAttach.cat === 'Offline' ? 'primary white--text' : ''" @click="loadCategoryImage('Offline')">Offline ({{ lDailyUpdateAttach.fileUrls && lDailyUpdateAttach.fileUrls.filter(rec => rec.operation).length }})</v-chip>
        </v-flex>
      </v-card-title>
      <v-card-text>
        <v-card flat>
          <v-container grid-list-md class="pa-0">
            <v-layout row wrap v-if="lDailyUpdateAttach.files && lDailyUpdateAttach.files.length > 0">
              <v-flex xs12 sm4 v-for="(file, index) in lDailyUpdateAttach.files" :key="index" class="pa-1 text-xs-center">
                <v-card-media
                class="black--text caption"
                height="210px"
                :src="file.file_url"
                >
                <div style="position:absolute; top:0px; right:5px">
                <v-chip v-if="file.operation" small color="primary" dark class="ma-0 pa-0" style="height:24px; min-width: 24px; display: inline-flex; justify-content: center; align-items: center;"><v-icon small>cloud_off</v-icon></v-chip>
                  <v-menu @input="$forceUpdate()"
                  top right class="mt-0">
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" small color="grey lighten-2">
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>
                  <!-- list of menuitems -->
                  <v-list class="py-0">
                    <v-list-tile @click="!isOnline && !file.is_offline ? msg('No internet connection. Please check your network and try again.', 0) : PrepareNotes(file)">
                      <v-list-tile-avatar><v-icon>notes</v-icon></v-list-tile-avatar>
                      <v-list-tile-title>Notes</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="!isOnline && !file.is_offline ? msg('No internet connection. Please check your network and try again.', 0) : PrepareUpdateCat(file)">
                      <v-list-tile-avatar><v-icon>edit</v-icon></v-list-tile-avatar>
                      <v-list-tile-title>Update category</v-list-tile-title>
                    </v-list-tile>
                    <v-divider></v-divider>
                    <v-list-tile @click.stop="!isOnline && !file.is_offline ? msg('No internet connection. Please check your network and try again.', 0) : deletePhoto(file)">
                      <v-list-tile-avatar><v-icon>delete</v-icon></v-list-tile-avatar>
                      <v-list-tile-title>Delete photo</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </div>
              <div class="white--text" style="background-color:rgba(125, 125, 125, 0.5);">{{handy.formatDBDateTime(file.attach_timestamp)}}<br />by {{file.user_name}}</div>
              <div style="position:absolute; bottom:0px; width:100%; background-color:rgba(0, 0, 255, 0.5);" class="text-xs-center white--text" v-if="file.notes">
                {{ file.notes }}
              </div>
            </v-card-media>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-else>
          <span>
            <div class="pa-2">No photos are taken yet.</div>
          </span>
        </v-layout>
      </v-container>
    </v-card>
  </v-card-text>
  <v-card-actions class="grey lighten-4 caption">
    <v-layout row wrap>
      <v-flex sm6 xs0>
        <v-spacer></v-spacer>
      </v-flex>
      <v-flex xs12 class="text-xs-center text-sm-right">
        <camera-and-file-picker @upload="uploadPhoto" @camera-opened="prepareCamera" :show-upload="config.IS_ADMIN">
          <template slot="camera-dialog-actions">
            <v-flex xs12>
              <v-select
              v-model="lDailyUpdateAttach.attach_cat_id"
              :items="photoCatChips"
              item-value="attach_cat_id"
              item-text="attach_cat_name"
              label="Category"
              hide-details
              :rules="[rules.required]"
              solo
              ></v-select>
            </v-flex>
          </template>
        </camera-and-file-picker>
      </v-flex>
    </v-layout>
  </v-card-actions>
</v-card>
</v-dialog>

<!-- Add/update notes -->
<v-dialog v-model="showNotes" persistent max-width="500px">
  <v-card>
    <v-card-title class="title grey lighten-4">
      Add or Update Notes
    </v-card-title>
    <v-card-text class="py-0">
      <v-img :src="lNotes.file_url" height="150px" contain class="mb-2" v-if="lNotes.file_url" />
      <v-flex xs12 class="pt-0">
        <v-textarea
        v-model="lNotes.notes"
        label="Notes"
        hide-details
        rows="2"
        ></v-textarea>
      </v-flex>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click.stop="showNotes = false">Cancel</v-btn>
      <v-btn flat type="submit" color="accent" @click="saveNotes(lNotes)">Save</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<!-- Update category -->
<v-dialog v-model="showCats" persistent max-width="300px">
  <v-card>
    <v-card-title class="title grey lighten-4">
      Update Category
    </v-card-title>
    <v-card-text>
      <v-img :src="lCat.file_url" height="150px" contain class="mb-2" v-if="lCat.file_url" />
      <v-flex xs12>
        <v-select
        v-model="lCat.attach_cat_id"
        :items="photoCatChips"
        item-value="attach_cat_id"
        item-text="attach_cat_name"
        label="Category"
        hide-details
        :rules="[rules.required]"
        solo
        ></v-select>
      </v-flex>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click.stop="showCats = false">Cancel</v-btn>
      <v-btn flat type="submit" color="accent" @click="saveCats(lCat)">Save</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<!-- 3. show Timeline for particular task_id -->
<v-dialog v-model="showTimeline" scrollable max-width="600px">
  <v-card>
    <v-card-title class="py-1 title grey lighten-4">
      <div>Timeline</div>
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="showTimeline = false"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-card-text>
      <v-timeline dense class="pt-0">
        <v-timeline-item :class="n === lTimeLine.length-1 ? 'pb-0' : ''"
        v-for="(timeline, n) in lTimeLine"
        :key="n" color="red lighten-2"
        small
        icon="star" fill-dot
        :id="'timeline_' + n"
        >
        <v-card>
          <v-card-text>
            {{ timeline.updated_by_name }} has
            <span v-if="timeline.category === 'Attach the photos' || timeline.category === 'Submitted for Approval' || timeline.category === 'Approved'"></span>
            <span v-else>updated</span>
            {{ timeline.category }}
            <span class="grey--text pl-1">on {{ handy.formatDate(timeline.action_dt) + ' ' + handy.getTime12Hrs(timeline.action_dt) }}</span>
          </v-card-text>
        </v-card>
      </v-timeline-item>
    </v-timeline>
  </v-card-text>
</v-card>
</v-dialog>

<!-- 4. -edit or update sanity checks value -->
<v-dialog v-model="showSanCheck" persistent scrollable max-width="650px">
  <v-card>
    <v-card-title class="pa-2 grey lighten-4">
      <div class="title grey--text" v-if="sanCheck.length > 0">{{sanCheck[0].check_cat}} <br v-if="!$vuetify.breakpoint.smAndUp" /><span class="subheading">{{'[' + handy.formatDate(lDate) + ']'}}</span></div>
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="showSanCheck = false"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pt-0">
      <v-flex xs12 v-for="(sanity, n) in sanCheck" :key="n">
        <v-layout row wrap>
          <v-flex xs4>
            <v-text-field
            v-model="sanity.check_desc"
            disabled
            hide-details
            class="pb-1"
            ></v-text-field>
          </v-flex>
          <v-flex xs1 class="pl-3">
            <v-checkbox v-model="sanity.check_value" :disabled="sanity.check_desc === 'Garbage Disposal' ? true : false" hide-details></v-checkbox>
          </v-flex>
          <v-flex xs7>
            <v-text-field
            v-model="sanity.remark"
            placeholder="Add remark if any"
            :disabled="sanity.check_desc === 'Garbage Disposal' ? true : false"
            hide-details
            class="pb-1"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="accent" @click="saveSanCheck(sanCheck, null)">save</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>


<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar" :timeout="3000" multi-line>
  <span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-container>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
import { VueEditor } from 'vue2-editor'
import CameraAndFilePicker from '@/components/CameraAndFilePicker'
import DailyUpdateBucket from '@/utils/DailyUpdateBucket'

export default {
  components:
  {
    VueEditor,
    CameraAndFilePicker
  },
  data () {
    return {
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      lAction: '',
      handy: handy,
      rules: handy.rules,
      config: config,
      beingSaved: false,
      chips: ['Today', 'Yesterday', 'Specific Date'],
      enableChip: '',
      watQual: [
        { text: 'Water Type', value: 'water_type' },
        { text: 'Parameter', value: 'param_name' },
        { text: 'Recommended', value: 'std_val_min' },
        { text: 'Value', value: 'val' }
      ],
      watQualDt: [
        { text: 'Water Type', value: 'water_type' },
        { text: 'Parameter', value: 'param_name' },
        { text: 'Recommended', value: 'std_val_min' },
        { text: 'Value', value: 'val' },
        { text: 'Date', value: 'c_date' }
      ],
      watQualSm: [
        { text: 'Water Type', value: 'water_type' },
        { text: 'Parameter', value: 'param_name' },
        { text: 'Value', value: 'val' }
      ],
      showWaterQual: false,
      lWatQual: [],
      dailyQualList: [],
      dlgDate: false,
      lDate: handy.formatDBDate(new Date()),
      lSummary: [],
      attendance: [
        { text: 'Present', value: 'tot_present' },
        { text: 'Weekoff', value: 'tot_wo' },
        { text: 'Holiday', value: 'tot_holiday' },
        { text: 'Standby/OT', value: 'tot_ot' },
        { text: 'Leave', value: 'tot_leave' },
        { text: 'Absent', value: 'tot_absent' },
        { text: 'Pending', value: 'tot_pend', class: 'red--text pa-2' },
        { text: 'Total', value: 'tot_staff', class: 'black--text pr-2' }
      ],
      attendanceSm: [
        { text: 'Present', value: 'tot_present' },
        { text: 'Pending', value: 'tot_pend', class: 'red--text pa-0' },
        { text: 'Total', value: 'tot_staff', class: 'black--text pr-0 pl-2' }
      ],
      watStorage: [
        { text: 'Name', value: 'storage_nm' },
        { text: 'Category', value: 'water_cat' },
        { text: 'Level (%)', value: 'water_level' },
        // { text: 'Receipt (KL)', value: 'water_receipt' },
        { text: 'Consumption (KL)', value: 'water_cons', class: 'pa-2' }
      ],
      watStorageDt: [
        { text: 'Name', value: 'storage_nm' },
        { text: 'Category', value: 'water_cat' },
        { text: 'Level (%)', value: 'water_level' },
        // { text: 'Receipt (KL)', value: 'water_receipt' },
        { text: 'Consumption (KL)', value: 'water_cons', class: 'pa-2' },
        { text: 'Date', value: 'c_date' }
      ],
      watList: [],
      lWatStorage: {},
      showWatStorage: false,
      domWatList: [],
      watTypeDt: [
        { text: 'Water Type', value: 'water_type' },
        { text: 'Value', value: 'water_receipt' },
        { text: 'Date', value: 'c_date' }
      ],
      watType: [
        { text: 'Water Type', value: 'water_type' },
        { text: 'Receipt (KL)', value: 'water_receipt' }
      ],
      lDomWat: [],
      showDomWat: false,
      powerCons: [
        { text: 'Meter', value: 'meter_nm' },
        { text: 'Units', value: 'units_cons' }
      ],
      powerConsDt: [
        { text: 'Meter', value: 'meter_nm' },
        { text: 'Units', value: 'units_cons' },
        { text: 'Date', value: 'c_date' }
      ],
      lPower: [],
      powerList: [],
      showPowerCons: false,
      genPower: [
        { text: 'Genset', value: 'genset_nm' },
        { text: 'Units Generated', value: 'units_cons' },
        { text: 'Current Diesel Level (%)', value: 'level' },
        { text: 'Purchased (ltr)', value: 'purchased' },
        { text: 'Stock (ltr)', value: 'stock' },
        { text: 'Running Hours', value: 'run_hrs' },
        { text: 'KWH/KVA', value: 'kwh_kva' }
      ],
      genPowerDt: [
        { text: 'Genset', value: 'genset_nm' },
        { text: 'Units Generated', value: 'units_cons' },
        { text: 'Current Diesel Level (%)', value: 'level' },
        { text: 'Purchased (ltr)', value: 'purchased' },
        { text: 'Stock (ltr)', value: 'stock' },
        { text: 'Running Hours', value: 'run_hrs' },
        { text: 'KWH/KVA', value: 'kwh_kva' },
        { text: 'Date', value: 'c_date' }
      ],
      showPowerGen: false,
      lGenset: [],
      gensetList: [],
      wasteMana: [
        { text: 'Wastage Type', value: 'waste_type' },
        { text: 'Kgs', value: 'kgs' }
      ],
      wasteManaDt: [
        { text: 'Wastage Type', value: 'waste_type' },
        { text: 'Kgs', value: 'kgs' },
        { text: 'Date', value: 'c_date' }
      ],
      wasteType: ['Organic', 'Dry', 'Rejected'],
      lWaste: [],
      lWasteList: [],
      showWaste: false,
      lSanCheck: {},
      sanCheckList: [],
      sanCheck: [],
      showSanCheck: false,
      lMet: {},
      metHead: [
        { text: 'Metric Name', value: 'metric_nm', width: '300px' },
        { text: 'Value', value: 'metric_val', width: '100px' }
      ],
      lMetric: [],
      metricList: [],
      showCusMet: false,
      lDailyUpdate: [{
        ia_app: 0,
        is_sub_app: 0,
        c_date: this.lDate,
        remark_attendance: '',
        remark_power: '',
        remark_water: '',
        comm_id: config.COMM_ID,
        updated_by: config.USER_ID
      }],
      showSummary: false,
      repHeadSm: [
        { text: 'Role [Headcount]', value: 'staff_role' },
        { text: 'Present', value: 'tot_present', class: 'pa-0' },
        { text: 'Weekoff', value: 'tot_wo' },
        { text: 'Holiday', value: 'tot_holiday' },
        { text: 'Standby/OT', value: 'tot_ot' },
        { text: 'Leave', value: 'tot_leave' },
        { text: 'Absent', value: 'tot_absent' },
        { text: 'Pending', value: 'tot_pend', class: 'red--text pa-0' }
      ],
      repHead: [
        { text: 'Role', value: 'staff_role' },
        { text: 'Present', value: 'tot_present', class: 'pa-0' },
        { text: 'Pending', value: 'tot_pend', class: 'red--text pa-0' }
      ],
      attReport: [],
      showUploadImage: false,
      lDailyUpdateAttach: [],
      photoCatChips: [],
      enablePreviousDay: false,
      dailyUpdatepreviousDayReport: [],
      showNotes: false,
      lNotes: {},
      showCats: false,
      lCat: {},
      showTimeline: false,
      lTimeLine: {},
      charLimit: 1000,
      charLen: 0,
      isOnline: false
    }
  },
  mounted () {
    this.lAction = 'view'
    this.loadDailyUpdateBasedOnPeriod('Today')
    // Initial status check on mount and show alert
    if (window.onlineListener) {
      const status = window.onlineListener()
      console.log('Initial Check inside Dailyupdate:', status)
      this.onConnectivityChange({ detail: status })
    }
    window.addEventListener('onlineListener', this.onConnectivityChange)
  },
  beforeDestroy () {
    window.removeEventListener('onlineListener', this.onConnectivityChange)
  },
  methods: {
    onConnectivityChange (e) {
      console.log('Connectivity changed event caught in Dailyupdate:', e.detail)
      // Determine isOnline based on the status
      this.isOnline = (e.detail === 'online')
      // Automatically sync data when returning to 'online' status
      if (this.isOnline) {
        this.syncOfflinePhotos()
      }
    },
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loadDailyAllUpdates (curDate) {
      this.loadDailyUpdate(curDate)
      this.loadWaterQuality(curDate)
      this.loadAttSummary(curDate)
      this.loadWaterTypeList(curDate)
      this.loadWaterStorage(curDate)
      this.loadPowerCons(curDate)
      this.loadPowerGenSet(curDate)
      this.loadWasteManagement(curDate)
      this.loadMetricCat()
      this.loadPhotoCat()
      this.loadFacDailyUpdateAttachment(curDate)
      this.loadSanCheckCat()
    },
    loadDailyUpdateBasedOnPeriod (curChip) {
      this.enableChip = curChip
      var targetDate = new Date()
      if (curChip === 'Yesterday') {
        targetDate.setDate(targetDate.getDate() - 1)
      } else if (curChip === 'Specific Date') {
        targetDate = new Date(this.lDate)
      }
      this.lDate = handy.formatDBDate(targetDate)
      this.fromDate = this.lDate
      this.loadDailyAllUpdates(this.fromDate)
      this.loadTimeLine(this.fromDate)
    },
    loadWaterQuality (curDate) {
      var previousDay = null
      var previousDate = []
      if (this.enablePreviousDay === true) {
        previousDay = new Date(curDate)
        previousDay.setDate(previousDay.getDate() - 1)
        previousDate = handy.formatDBDate(previousDay)
      }
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: previousDay ? previousDate : curDate,
          to_dt: curDate
        }
      }
      this.dailyQualList = []
      this.axios.get(config.API_URL + '/getDailyWaterQualityByCommId/', qry)
      .then(response => {
        var dailyQuality = response.data
        var curObj = []
        this.dailyQualList.curdateReport = dailyQuality.filter(rec => handy.formatDBDate(rec.c_date) === curDate)
        this.dailyQualList.previousDayReport = dailyQuality.filter(rec => handy.formatDBDate(rec.c_date) === previousDate)
        if (this.enablePreviousDay === true) {
          if (this.dailyQualList.previousDayReport.length !== 0) {
            curObj = this.dailyQualList.previousDayReport
            curObj = curObj.concat(this.dailyQualList.curdateReport)
          } else {
            curObj = response.data
          }
        } else {
          curObj = response.data
        }
        for (var i = 0; i < curObj.length; i++) {
          this.dailyQualList.push({
            c_date: curObj[i].c_date ? handy.formatDBDate(curObj[i].c_date) : this.lDate,
            param_id: curObj[i].param_id,
            param_name: curObj[i].param_name,
            std_val_max: curObj[i].std_val_max,
            std_val_min: curObj[i].std_val_min,
            uom: curObj[i].uom,
            val: curObj[i].val,
            water_type: curObj[i].water_type,
            water_type_id: curObj[i].water_type_id
          })
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareEditWaterQual (curWatQual) {
      this.lWatQual = Object.assign({}, curWatQual)
      this.showWaterQual = true
    },
    saveWatQualChanges () {
      if (!this.$refs.lForm.validate()) {
        return
      }
      this.beingSaved = true
      this.lWatQual.c_date = this.lDate
      this.lWatQual.comm_id = config.COMM_ID
      this.lWatQual.updated_by = config.USER_ID
      this.lWatQual.is_updated_by_sv_user = false
      this.lWatQual.is_sub_app = this.lDailyUpdate.is_sub_app ? this.lDailyUpdate.is_sub_app : 0
      this.lWatQual.is_app = this.lDailyUpdate.is_app ? this.lDailyUpdate.is_app : 0
      this.axios.post(config.API_URL + '/facilityDailyUpdate/water-qual', this.lWatQual)
      .then(response => {
        var idx = this.dailyQualList.findIndex(rec => (rec.c_date === this.lWatQual.c_date) && (rec.param_id === this.lWatQual.param_id))
        Object.assign(this.dailyQualList[idx], this.lWatQual)
        this.beingSaved = false
        this.showWaterQual = false
        this.loadDailyUpdate(this.lDate)
      })
      .catch(err => {
        this.msg(err, true)
        this.beingSaved = false
        this.showWaterQual = false
      })
    },
    loadAttSummary (curDate) {
      var previousDay = null
      if (this.enablePreviousDay === true) {
        previousDay = new Date(curDate)
        previousDay.setDate(previousDay.getDate() - 1)
      }
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: previousDay !== null ? handy.formatDBDate(previousDay) : curDate,
          to_dt: curDate,
          is_billable: 1
        }
      }
      this.lSummary = []
      this.axios.get(config.API_URL + '/getAttendanceByCommId/', qry)
      .then(response => {
        if (response.data.length) {
          this.lSummary.curdateReport = response.data.filter(rec => rec.att_dt === curDate)
          this.lSummary.previousDayReport = response.data.filter(rec => rec.att_dt === handy.formatDBDate(previousDay))
          var idx = 0
          var curObj = {}
          for (var i = 0; i <= (2 - idx); i++) {
            if (i === 0 && this.enablePreviousDay === true) {
              curObj = this.lSummary.previousDayReport
              idx++
            } else {
              curObj = this.lSummary.curdateReport
              idx += 2
            }
            this.lSummary.push({
              att_dt: curObj[0].att_dt,
              tot_staff: curObj.length,
              tot_present: curObj.filter(att => att.attendance && att.attendance.includes('Present')).length,
              tot_absent: curObj.filter(att => att.attendance === 'Absent').length,
              tot_leave: curObj.filter(att => att.attendance && att.attendance.includes('Leave')).length,
              tot_wo: curObj.filter(att => att.attendance && att.attendance.includes('Weekly Off')).length,
              tot_ot: curObj.filter(att => att.attendance && (att.attendance.includes('OT') || att.sby_vendor_emp_id || att.sby_temp_staff_name)).length,
              tot_pend: curObj.filter(att => !att.attendance).length,
              // adjust half days
              tot_holiday: curObj.filter(att => att.attendance && att.attendance.includes('Holiday')).length,
              tot_hd: curObj.filter(att => att.attendance === 'Half Day').length
            })
            this.lSummary[i].tot_present = this.lSummary[i].tot_present + (this.lSummary[i].tot_hd / 2)
            this.lSummary[i].tot_absent = this.lSummary[i].tot_absent + (this.lSummary[i].tot_hd / 2)
            this.lSummary[i].attAve = Math.round((this.lSummary[i].tot_present + this.lSummary[i].tot_ot + this.lSummary[i].tot_wo + this.lSummary[i].tot_holiday) / (this.lSummary[i].tot_staff) * 100)
          }
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    showAttendanceSummary (curdate) {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: curdate,
          to_dt: curdate,
          group_by: 'role',
          is_billable: 1
        }
      }
      this.showSummary = true
      this.attReport = []
      this.axios.get(config.API_URL + '/getAttendanceRep/', qry)
      .then(response => {
        this.attReport = response.data
        // calculate few fields
        this.attReport.forEach(rec => {
          rec.staff_role = rec.staff_role + ' [' + rec.role_count + ']'
          rec.tot_present = rec.tot_present + (rec.tot_hd / 2)
          rec.tot_absent = rec.tot_absent + (rec.tot_hd / 2)
        })
      })
      .catch(err => {
        this.msg(err.response.data, 0)
      })
    },
    loadWaterStorage (curDate) {
      var previousDay = null
      var previousDate = []
      if (this.enablePreviousDay === true) {
        previousDay = new Date(curDate)
        previousDay.setDate(previousDay.getDate() - 1)
        previousDate[0] = handy.formatDBDate(previousDay)
        previousDate[1] = curDate
      }
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          c_date: previousDay !== null ? previousDate : curDate
        }
      }
      this.watList = []
      this.axios.get(config.API_URL + '/getWaterStorageByCommIdAndcDate/', qry)
      .then(response => {
        if (this.enablePreviousDay === true) {
          this.watList.curdateReport = response.data.filter(rec => handy.formatDBDate(rec.c_date) === curDate)
          this.watList.previousDayReport = response.data.filter(rec => handy.formatDBDate(rec.c_date) === previousDate[0])
        }
        var curObj = []
        if (this.enablePreviousDay === true) {
          if (this.watList.previousDayReport.length === 0) {
            curObj = response.data
          } else {
            curObj = this.watList.previousDayReport
            curObj = curObj.concat(this.watList.curdateReport)
          }
        } else {
          curObj = response.data
        }
        for (var i = 0; i < curObj.length; i++) {
          this.watList.push({
            c_date: curObj[i].c_date === null ? this.lDate : handy.formatDBDate(curObj[i].c_date),
            storage_id: curObj[i].storage_id,
            storage_nm: curObj[i].storage_nm,
            water_cat: curObj[i].water_cat,
            water_cons: curObj[i].water_cons,
            water_level: curObj[i].water_level,
            water_receipt: curObj[i].water_receipt,
            is_cons_checked: curObj[i].is_cons_checked,
            is_level_checked: curObj[i].is_level_checked,
            is_receipt_checked: curObj[i].is_receipt_checked
          })
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    PreapreEditWatStorage (curWarSt) {
      this.lWatStorage = Object.assign({}, curWarSt)
      this.showWatStorage = true
    },
    saveWatStorageChanges () {
      if (!this.$refs.sForm.validate()) {
        return
      }
      if (this.lWatStorage.water_level < 0 || this.lWatStorage.water_level > 100) {
        this.msg('Please add the values of level between 0-100 only', 0)
      } else {
        this.beingSaved = true
        this.lWatStorage.c_date = this.lDate
        this.lWatStorage.comm_id = config.COMM_ID
        this.lWatStorage.updated_by = config.USER_ID
        this.lWatStorage.is_updated_by_sv_user = false
        this.lWatStorage.is_sub_app = this.lDailyUpdate.is_sub_app ? this.lDailyUpdate.is_sub_app : 0
        this.lWatStorage.is_app = this.lDailyUpdate.is_app ? this.lDailyUpdate.is_app : 0
        this.lWatStorage.water_level = this.lWatStorage.water_level ? this.lWatStorage.water_level : null
        this.lWatStorage.water_receipt = this.lWatStorage.water_receipt ? this.lWatStorage.water_receipt : null
        this.lWatStorage.water_cons = this.lWatStorage.water_cons ? this.lWatStorage.water_cons : null
        this.axios.post(config.API_URL + '/facilityDailyUpdate/water-storage', this.lWatStorage)
        .then(response => {
          var idx = this.watList.findIndex(rec => (rec.c_date === this.lWatStorage.c_date) && (rec.storage_id === this.lWatStorage.storage_id))
          Object.assign(this.watList[idx], this.lWatStorage)
          this.beingSaved = false
          this.showWatStorage = false
          this.loadDailyUpdate(this.lDate)
        })
        .catch(err => {
          this.beingSaved = false
          this.msg(err, 0)
        })
      }
    },
    loadWaterTypeList (curDate) {
      var previousDay = null
      var previousDate = []
      if (this.enablePreviousDay === true) {
        previousDay = new Date(curDate)
        previousDay.setDate(previousDay.getDate() - 1)
        previousDate[0] = handy.formatDBDate(previousDay)
        previousDate[1] = curDate
      }
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          c_date: previousDay !== null ? previousDate : curDate,
          from_dt: previousDay !== null ? previousDate : curDate,
          to_dt: previousDay !== null ? previousDate : curDate
        }
      }
      this.domWatList = []
      this.axios.get(config.API_URL + '/getWaterSourcesByCommIdAndcDate/', qry)
      .then(response => {
        this.domWatList.curdateReport = response.data.filter(rec => handy.formatDBDate(rec.c_date) === curDate)
        this.domWatList.previousDayReport = response.data.filter(rec => handy.formatDBDate(rec.c_date) === previousDate[0])
        var curObj = []
        if (this.enablePreviousDay === true) {
          if (this.domWatList.previousDayReport.length === 0) {
            curObj = response.data
          } else {
            curObj = this.domWatList.previousDayReport
            curObj = curObj.concat(this.domWatList.curdateReport)
          }
        } else {
          curObj = response.data
        }
        for (var i = 0; i < response.data.length; i++) {
          this.domWatList.push({
            c_date: curObj[i].c_date === null ? this.lDate : handy.formatDBDate(curObj[i].c_date),
            water_type: curObj[i].water_type,
            water_type_id: curObj[i].water_type_id,
            water_receipt: curObj[i].water_receipt
          })
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    PreapreEditDomWatList (curWatType) {
      this.lDomWat = Object.assign({}, curWatType)
      this.showDomWat = true
    },
    saveDomWatChanges () {
      if (!this.$refs.dForm.validate()) {
        return
      }
      this.beingSaved = true
      this.lDomWat.c_date = this.lDate
      this.lDomWat.comm_id = config.COMM_ID
      this.lDomWat.updated_by = config.USER_ID
      this.lDomWat.is_updated_by_sv_user = false
      this.lDomWat.is_sub_app = this.lDailyUpdate.is_sub_app ? this.lDailyUpdate.is_sub_app : 0
      this.lDomWat.is_app = this.lDailyUpdate.is_app ? this.lDailyUpdate.is_app : 0
      this.axios.post(config.API_URL + '/facilityDailyUpdate/water-sources', this.lDomWat)
      .then(response => {
        var idx = this.domWatList.findIndex(rec => (rec.c_date === this.lDomWat.c_date) && (rec.water_type_id === this.lDomWat.water_type_id))
        Object.assign(this.domWatList[idx], this.lDomWat)
        this.beingSaved = false
        this.showDomWat = false
        this.loadDailyUpdate(this.lDate)
      })
      .catch(err => {
        this.beingSaved = false
        this.msg(err, 0)
      })
    },
    loadPowerCons (curDate) {
      var previousDay = null
      var previousDate = []
      if (this.enablePreviousDay === true) {
        previousDay = new Date(curDate)
        previousDay.setDate(previousDay.getDate() - 1)
        previousDate[0] = handy.formatDBDate(previousDay)
        previousDate[1] = curDate
      }
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          c_date: previousDay !== null ? previousDate : curDate
        }
      }
      this.powerList = []
      this.axios.get(config.API_URL + '/getPowerConsByCommIdAndcDate/', qry)
      .then(response => {
        this.powerList.filtereditems = response.data.filter(rec => rec.meter_nm !== '')
        this.powerList.curdateReport = this.powerList.filtereditems.filter(rec => handy.formatDBDate(rec.c_date) === curDate)
        this.powerList.previousDayReport = this.powerList.filtereditems.filter(rec => handy.formatDBDate(rec.c_date) === previousDate[0])
        var curObj = []
        if (this.enablePreviousDay === true) {
          if (this.powerList.previousDayReport.length === 0) {
            curObj = this.powerList.filtereditems
          } else {
            curObj = this.powerList.previousDayReport
            curObj = curObj.concat(this.powerList.curdateReport)
          }
        } else {
          curObj = this.powerList.filtereditems
        }
        for (var i = 0; i < this.powerList.filtereditems.length; i++) {
          this.powerList.push({
            c_date: curObj[i].c_date === null ? this.lDate : handy.formatDBDate(curObj[i].c_date),
            meter_id: curObj[i].meter_id,
            meter_nm: curObj[i].meter_nm,
            meter_location: curObj[i].meter_location,
            units_cons: curObj[i].units_cons ? curObj[i].units_cons.toFixed(2) : ''
          })
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareEditCons (curCons) {
      this.lPower = Object.assign({}, curCons)
      this.showPowerCons = true
    },
    savePowerConsChanges () {
      if (!this.$refs.pForm.validate()) {
        return
      }
      this.beingSaved = true
      this.lPower.c_date = this.lDate
      this.lPower.comm_id = config.COMM_ID
      this.lPower.updated_by = config.USER_ID
      this.lPower.is_updated_by_sv_user = false
      this.lPower.is_sub_app = this.lDailyUpdate.is_sub_app ? this.lDailyUpdate.is_sub_app : 0
      this.lPower.is_app = this.lDailyUpdate.is_app ? this.lDailyUpdate.is_app : 0
      this.axios.post(config.API_URL + '/facilityDailyUpdate/power-cons', this.lPower)
      .then(response => {
        var idx = this.powerList.findIndex(rec => (rec.c_date === this.lPower.c_date) && (rec.meter_id === this.lPower.meter_id))
        Object.assign(this.powerList[idx], this.lPower)
        this.beingSaved = false
        this.showPowerCons = false
        this.loadDailyUpdate(this.lDate)
        this.loadPowerCons(this.lDate)
      })
      .catch(err => {
        this.beingSaved = false
        this.msg(err.response.data, 0)
      })
    },
    loadPowerGenSet (curDate) {
      var previousDay = null
      var previousDate = []
      if (this.enablePreviousDay === true) {
        previousDay = new Date(curDate)
        previousDay.setDate(previousDay.getDate() - 1)
        previousDate = handy.formatDBDate(previousDay)
      }
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: previousDay !== null ? previousDate : curDate,
          to_dt: curDate
        }
      }
      this.gensetList = []
      this.axios.get(config.API_URL + '/getPowerGensetByCommIdAndcDate/', qry)
      .then(response => {
        this.gensetList.curdateReport = response.data.filter(rec => handy.formatDBDate(rec.c_date) === curDate)
        this.gensetList.previousDayReport = response.data.filter(rec => handy.formatDBDate(rec.c_date) === previousDate)
        var curObj = []
        if (this.enablePreviousDay === true) {
          if (this.gensetList.previousDayReport.length === 0) {
            curObj = response.data
          } else {
            curObj = this.gensetList.previousDayReport
            curObj = curObj.concat(this.gensetList.curdateReport)
          }
        } else {
          curObj = response.data
        }
        for (var i = 0; i < response.data.length; i++) {
          this.gensetList.push({
            c_date: curObj[i].c_date === null ? this.lDate : handy.formatDBDate(curObj[i].c_date),
            genset_id: curObj[i].genset_id,
            genset_nm: curObj[i].genset_nm,
            units_cons: curObj[i].units_cons,
            level: curObj[i].level,
            purchased: curObj[i].purchased,
            stock: curObj[i].stock,
            run_hrs: curObj[i].run_hrs,
            kwh_kva: curObj[i].kwh_kva
          })
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareEditGen (curGen) {
      this.lGenset = Object.assign({}, curGen)
      this.showPowerGen = true
    },
    savePowerGenChanges () {
      if (!this.$refs.gForm.validate()) {
        return
      }
      if (this.lGenset.level < 0 || this.lGenset.level > 100) {
        this.msg('Please add the values of level between 0-100 only', 0)
      } else {
        this.beingSaved = true
        this.lGenset.c_date = this.lDate
        this.lGenset.comm_id = config.COMM_ID
        this.lGenset.updated_by = config.USER_ID
        this.lGenset.is_updated_by_sv_user = false
        this.lGenset.is_sub_app = this.lDailyUpdate.is_sub_app ? this.lDailyUpdate.is_sub_app : 0
        this.lGenset.is_app = this.lDailyUpdate.is_app ? this.lDailyUpdate.is_app : 0
        this.axios.post(config.API_URL + '/facilityDailyUpdate/power-genset', this.lGenset)
        .then(response => {
          var idx = this.gensetList.findIndex(rec => (rec.c_date === this.lGenset.c_date) && (rec.genset_id === this.lGenset.genset_id))
          Object.assign(this.gensetList[idx], this.lGenset)
          this.beingSaved = false
          this.showPowerGen = false
          this.loadDailyUpdate(this.lDate)
        })
        .catch(err => {
          this.beingSaved = false
          this.msg(err.response.data, 0)
        })
      }
    },
    loadWasteManagement (curDate) {
      var previousDay = null
      var previousDate = []
      if (this.enablePreviousDay === true) {
        previousDay = new Date(curDate)
        previousDay.setDate(previousDay.getDate() - 1)
        previousDate = handy.formatDBDate(previousDay)
      }
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: previousDay !== null ? previousDate : curDate,
          to_dt: curDate
        }
      }
      this.lWasteList = []
      this.axios.get(config.API_URL + '/getWasteByCommIdAndcDate/', qry)
      .then(response => {
        var wasteList = response.data.map(rec => rec.waste_type)
        this.lWasteList.curdateReport = response.data.filter(rec => handy.formatDBDate(rec.c_date) === curDate)
        this.lWasteList.previousDayReport = response.data.filter(rec => handy.formatDBDate(rec.c_date) === previousDate)
        var cIdx = 0
        var curObj = []
        if (this.enablePreviousDay === true) {
          curObj = this.lWasteList.previousDayReport
          curObj = curObj.concat(this.lWasteList.curdateReport)
        } else {
          curObj = response.data
        }

        for (var i = 0; i < response.data.length; i++) {
          this.lWasteList.push({
            c_date: handy.formatDBDate(curObj[i].c_date),
            waste_type: curObj[i].waste_type,
            kgs: curObj[i].kgs
          })
        }
        // fill-in gaps
        this.wasteType.forEach(type => {
          cIdx = wasteList.indexOf(type)
          if (cIdx < 0) {
            this.lWasteList.push({
              waste_type: type,
              kgs: '',
              c_date: this.lDate
            })
          }
        })
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareEditWaste (curWaste) {
      this.lWaste = Object.assign({}, curWaste)
      this.showWaste = true
    },
    saveWasteChanges () {
      if (!this.$refs.wForm.validate()) {
        return
      }
      this.beingSaved = true
      this.lWaste.c_date = this.lDate
      this.lWaste.comm_id = config.COMM_ID
      this.lWaste.updated_by = config.USER_ID
      this.lWaste.is_updated_by_sv_user = false
      this.lWaste.is_sub_app = this.lDailyUpdate.is_sub_app ? this.lDailyUpdate.is_sub_app : 0
      this.lWaste.is_app = this.lDailyUpdate.is_app ? this.lDailyUpdate.is_app : 0
      this.axios.post(config.API_URL + '/facilityDailyUpdate/waste-management', this.lWaste)
      .then(response => {
        var idx = this.lWasteList.findIndex(rec => (rec.c_date === this.lWaste.c_date) && (rec.waste_type === this.lWaste.waste_type))
        Object.assign(this.lWasteList[idx], this.lWaste)
        this.beingSaved = false
        this.showWaste = false
        this.loadDailyUpdate(this.lDate)
        this.sanCheckList.forEach(rec => {
          if (rec.check_desc.includes('Garbage Disposal')) {
            var idx = this.sanCheckList.findIndex(rec => rec.check_desc === 'Garbage Disposal')
            this.sanCheckList[idx].remark = ''
            var string = ''
            this.lWasteList.forEach(waste => {
              if (waste.kgs) {
                string += waste.waste_type + ': ' + waste.kgs + 'kg '
                this.sanCheckList[idx].remark = string
              }
            })
            if (this.sanCheckList[idx].remark) {
              this.sanCheckList[idx].c_date = this.lDate
              this.sanCheckList[idx].comm_id = config.COMM_ID
              this.sanCheckList[idx].updated_by = config.USER_ID
              this.sanCheckList[idx].is_updated_by_sv_user = false
              this.sanCheckList[idx].check_value = true
              this.saveSanCheck(this.sanCheckList[idx], string)
            } else {
              this.sanCheckList[idx].check_value = false
            }
          }
        })
      })
      .catch(err => {
        this.showWaste = false
        this.beingSaved = false
        this.msg(err.response.data, 0)
      })
    },
    loadSanCheckCat () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getSanCheckCatByCommId/', qry)
      .then(response => {
        this.lSanCheck = response.data
        this.loadSanCheck(this.lDate)
      })
      .catch(err => {
        this.msg(err.response.data, 0)
      })
    },
    loadSanCheck (curDate) {
      var previousDay = null
      var previousDate = []
      if (this.enablePreviousDay === true) {
        previousDay = new Date(curDate)
        previousDay.setDate(previousDay.getDate() - 1)
        previousDate = handy.formatDBDate(previousDay)
      }
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: previousDay !== null ? previousDate : curDate,
          to_dt: curDate
        }
      }
      this.sanCheckList = []
      this.axios.get(config.API_URL + '/getSanCheckByCommIdAndcDate/', qry)
      .then(response => {
        this.sanCheckList.curdateReport = response.data.filter(rec => handy.formatDBDate(rec.c_date) === curDate)
        this.sanCheckList.previousDayReport = response.data.filter(rec => handy.formatDBDate(rec.c_date) === previousDate)
        var curObj = []
        if (this.enablePreviousDay === true) {
          if (this.sanCheckList.previousDayReport.length === 0) {
            curObj = response.data
          } else {
            curObj = this.sanCheckList.previousDayReport
            curObj = curObj.concat(this.sanCheckList.curdateReport)
          }
        } else {
          curObj = response.data
        }
        for (var i = 0; i < response.data.length; i++) {
          this.sanCheckList.push({
            c_date: curObj[i].c_date === null ? this.lDate : handy.formatDBDate(curObj[i].c_date),
            check_cat: curObj[i].check_cat,
            check_desc: curObj[i].check_desc,
            check_id: curObj[i].check_id,
            check_value: curObj[i].check_value,
            remark: curObj[i].remark
          })
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareEditSanCheck (curcat) {
      this.sanCheck = this.sanCheckList.filter(rec => rec.check_cat === curcat)
      this.showSanCheck = true
    },
    saveSanCheck (curSanCheck, curString) {
      for (var i = 0; i < curSanCheck.length; i++) {
        curSanCheck[i].is_updated_by_sv_user = false
        curSanCheck[i].is_sub_app = this.lDailyUpdate.is_sub_app ? this.lDailyUpdate.is_sub_app : 0
        curSanCheck[i].is_app = this.lDailyUpdate.is_app ? this.lDailyUpdate.is_app : 0
        curSanCheck[i].comm_id = config.COMM_ID
        curSanCheck[i].updated_by = config.USER_ID
        this.axios.post(config.API_URL + '/facilityDailyUpdate/sancheck', curSanCheck[i])
        .then(response => {
          if (!curString) {
            this.msg('Saved successfully', 1)
          }
          // this.loadDailyUpdate(this.lDate)
          // this.showSanCheck = false
        })
        .catch(err => {
          this.msg(err.response.data, 0)
        })
      }
      this.loadDailyUpdate(this.lDate)
      this.showSanCheck = false
    },
    loadMetricCat () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getMetricCatByCommId/', qry)
      .then(response => {
        this.lMet = response.data.filter(rec => rec.metric_cat !== '')
        this.loadMetric(this.lDate)
      })
      .catch(err => {
        this.msg(err.response.data, 0)
      })
    },
    loadMetric (curDate) {
      var metCat = this.lMet.filter(rec => rec.metric_cat !== '')
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          from_dt: curDate,
          to_dt: curDate,
          metric_cat: metCat.map(rec => rec.metric_cat)
        }
      }
      this.axios.get(config.API_URL + '/getMetricByCommId/', qry)
      .then(response => {
        this.metricList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, 0)
      })
    },
    prepareEditCusMet (curCusMet) {
      this.lMetric = Object.assign({}, curCusMet)
      this.showCusMet = true
    },
    saveMetChanges () {
      this.lMetric.c_date = this.lDate
      this.lMetric.comm_id = config.COMM_ID
      this.lMetric.updated_by = config.USER_ID
      this.lMetric.is_updated_by_sv_user = false
      this.lMetric.is_sub_app = this.lDailyUpdate.is_sub_app ? this.lDailyUpdate.is_sub_app : 0
      this.lMetric.is_app = this.lDailyUpdate.is_app ? this.lDailyUpdate.is_app : 0
      this.axios.post(config.API_URL + '/facilityDailyUpdate/cus-metric', this.lMetric)
      .then(response => {
        var idx = this.metricList.findIndex(rec => rec.metric_id === this.lMetric.metric_id)
        Object.assign(this.metricList[idx], this.lMetric)
        this.beingSaved = false
        this.showCusMet = false
        this.loadDailyUpdate(this.lDate)
      })
      .catch(err => {
        this.msg(err, 0)
        this.beingSaved = false
        this.showCusMet = false
      })
    },
    limitChar (curMajorObser) {
      this.charLen = handy.fixHtmlSpacing(curMajorObser).length
      if (handy.fixHtmlSpacing(curMajorObser).length > this.charLimit) {
        this.msg('Exceeding the character limit', 0)
      }
    },
    postObserv () {
      if (this.lDailyUpdate.major_observ.length > 1000) {
        this.msg('Exceeding the character limit, Please enter below 1000 characters', 0)
      }
      var remark = {}
      remark.remark_attendance = this.lDailyUpdate.remark_attendance
      remark.remark_water = this.lDailyUpdate.remark_water
      remark.remark_power = this.lDailyUpdate.remark_power
      remark.remark_sanity_checks = this.lDailyUpdate.remark_sanity_checks
      remark.remark_custom_metrics = this.lDailyUpdate.remark_custom_metrics
      remark.major_observ = this.lDailyUpdate.major_observ
      remark.c_date = this.lDate
      remark.comm_id = config.COMM_ID
      remark.updated_by = config.USER_ID
      remark.is_updated_by_sv_user = false
      remark.is_sub_app = this.lDailyUpdate.is_sub_app ? this.lDailyUpdate.is_sub_app : 0
      remark.is_app = this.lDailyUpdate.is_app ? this.lDailyUpdate.is_app : 0
      this.axios.post(config.API_URL + '/facilityDailyUpdate/major-observ', remark)
      .then(response => {
        this.msg('Saved successfully', 1)
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadDailyUpdate (curDate) {
      var previousDay = null
      var previousDate = []
      if (this.enablePreviousDay === true) {
        previousDay = new Date(curDate)
        previousDay.setDate(previousDay.getDate() - 1)
        previousDate[0] = handy.formatDBDate(previousDay)
        previousDate[1] = curDate
      }
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          c_date: previousDay !== null ? previousDate : curDate
        }
      }
      this.lDailyUpdate = []
      this.axios.get(config.API_URL + '/getDailyUpdateByDate/', qry)
      .then(response => {
        if (response.data.length) {
          if (this.enablePreviousDay === true) {
            this.dailyUpdatepreviousDayReport = response.data.filter(rec => handy.formatDBDate(rec.c_date) === previousDate[0])[0] || {}
            this.lDailyUpdate = response.data.filter(rec => handy.formatDBDate(rec.c_date) === curDate)[0] || {}
            if (!this.dailyUpdatepreviousDayReport.c_date) {
              this.msg('Previous day update is not available', 0)
            }
          } else {
            this.lDailyUpdate = response.data[0]
          }
          if (this.lDailyUpdate.is_app_by_sv_user || this.lDailyUpdate.is_updated_by_sv_user) {
            var qry1 = {
              params: {
                user_id: this.lDailyUpdate.updated_by
              }
            }
            this.axios.get(config.API_URL + '/getCustNameOfSVUser/', qry1)
            .then(response => {
              this.lDailyUpdate.cust_name = handy.startWithUpper(response.data[0].user_name)
            })
          }
        }
        this.loadTimeLine(curDate)
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    submitApproval () {
      this.lDailyUpdate.c_date = this.lDate
      this.lDailyUpdate.updated_by = config.USER_ID
      this.lDailyUpdate.is_updated_by_sv_user = false
      this.axios.post(config.API_URL + '/facilityDailyUpdate/submit-for-approval', this.lDailyUpdate)
      .then(response => {
        this.msg('Successfully submitted for approval', false)
        this.loadDailyUpdate(this.lDate)
      })
      .catch(err => {
        this.msg(err.response.data, 0)
      })
    },
    approveUpdate () {
      if (!confirm('Sure, you want to Approve it ?')) {
        return
      }
      this.lDailyUpdate.c_date = this.lDate
      this.lDailyUpdate.app_by = config.USER_ID
      this.lDailyUpdate.is_app_by_sv_user = false
      this.axios.post(config.API_URL + '/facilityDailyUpdate/approve-dailyupdate', this.lDailyUpdate)
      .then(response => {
        this.msg('Approved successfully', false)
        this.loadDailyUpdate(this.lDate)
      })
      .catch(err => {
        this.msg(err.response.data, 0)
      })
    },
    prepareCamera () {
      this.lDailyUpdateAttach.attach_category = !this.lDailyUpdateAttach.cat || this.lDailyUpdateAttach.cat === 'All' ? 'Briefing' : this.lDailyUpdateAttach.cat
    },
    async loadFacDailyUpdateAttachment (curDate) {
      var qry = {
        params: {
          from_dt: curDate,
          to_dt: curDate,
          comm_id: config.COMM_ID
        }
      }
      const findFileIdx = (data, list) => list.findIndex(rec => {
        const recFileName = rec.file_name || (rec.file_url ? rec.file_url.split('/').pop() : '')
        const dataFileName = data.file_name || (data.file_url ? data.file_url.split('/').pop() : '')
        return recFileName === dataFileName && recFileName !== ''
      })
      this.axios.get(config.API_URL + '/getAttachmentByCDate/', qry)
      .then(async response => {
        const serverPhotos = response.data || []
        const offlinePhotos = (await DailyUpdateBucket.getAllPhotos())
        // Merge Server and Offline Photos
        const workingList = [...serverPhotos]
        for (const item of offlinePhotos) {
          const finalData = { ...item, offline_key: item.id, is_offline: true }
          if (item.image) {
            if (item.image instanceof Blob) {
              finalData.file_url = URL.createObjectURL(item.image)
            } else if (typeof item.image === 'string' && item.image.startsWith('data:image')) {
              finalData.file_url = item.image
            }
          }
          const idx = findFileIdx(item, workingList)
          if (item.operation === 'delete') {
            if (idx > -1) {
              workingList.splice(idx, 1)
            }
          } else {
            // Add
            if (idx <= -1) {
              workingList.push(finalData)
            } else {
              // Update
              workingList[idx] = finalData
            }
          }
        }
        console.log('Hello', workingList.map((e) => e.file_url))
        this.lDailyUpdateAttach.fileUrls = workingList
        this.lDailyUpdateAttach.cat = this.lDailyUpdateAttach.cat || 'All'
        if (this.lDailyUpdateAttach.cat === 'All') {
          this.lDailyUpdateAttach.files = this.lDailyUpdateAttach.fileUrls
        } else {
          this.lDailyUpdateAttach.files = this.lDailyUpdateAttach.fileUrls.filter(rec => rec.attach_cat_id === this.lDailyUpdateAttach.cat)
        }
        this.$forceUpdate()
      })
      .catch(async err => {
        this.msg(err.response ? err.response.data : err.message, 0)
        // Show offline photos even if the server is unreachable
        const offlinePhotos = (await DailyUpdateBucket.getAllPhotos())
        // Use a Set to avoid duplicates if merge logic is called multiple times
        const uniqueSet = new Set(this.lDailyUpdateAttach.fileUrls.map(f => f.id || f.offline_key))
        offlinePhotos.forEach(item => {
          const finalData = { ...item, offline_key: item.id, is_offline: true }
          if (item.image) {
            if (item.image instanceof Blob) {
              finalData.file_url = URL.createObjectURL(item.image)
            } else if (typeof item.image === 'string' && item.image.startsWith('data:image')) {
              finalData.file_url = item.image
            }
          }
          const idx = findFileIdx(item, this.lDailyUpdateAttach.fileUrls)
          if (item.operation === 'delete') {
            if (idx > -1) {
              this.lDailyUpdateAttach.fileUrls.splice(idx, 1)
            }
          } else {
            if (idx <= -1) {
              if (!uniqueSet.has(item.id || item.offline_key)) {
                this.lDailyUpdateAttach.fileUrls.push(finalData)
                uniqueSet.add(item.id || item.offline_key)
              }
            } else {
              this.lDailyUpdateAttach.fileUrls[idx] = finalData
            }
          }
        })
        this.lDailyUpdateAttach.files = [...this.lDailyUpdateAttach.fileUrls]
        this.$forceUpdate()
      })
    },
    PrepareNotes (curFile) {
      this.lNotes = Object.assign({}, curFile)
      this.showNotes = true
    },
    async saveNotes (curNotes) {
      this.beingSaved = true
      // Case: Photo is already offline/pending in IndexedDB
      if (!this.isOnline || curNotes.operation) {
        if (curNotes.operation) {
          await DailyUpdateBucket.updatePhoto(curNotes)
        }
        var idx = this.lDailyUpdateAttach.files.findIndex(rec => (rec.c_date === curNotes.c_date) && (rec.comm_id === curNotes.comm_id) && (rec.file_url === curNotes.file_url))
        if (idx > -1) {
          Object.assign(this.lDailyUpdateAttach.files[idx], curNotes)
        }
        this.beingSaved = false
        this.showNotes = false
        if (!this.isOnline) {
          this.msg('Offline! Note saved locally.', 2)
          return
        }
      }
      // command->user intraction Dailyupdate (/daily-update) -> Photos -> Add Notes -> (Stay) -> API Route: /facilityDailyUpdateAttach/notes
      this.axios.post(config.API_URL + '/facilityDailyUpdateAttach/notes', curNotes)
      .then(response => {
        var idx = this.lDailyUpdateAttach.files.findIndex(rec => (rec.c_date === curNotes.c_date) && (rec.comm_id === curNotes.comm_id) && (rec.file_url === curNotes.file_url))
        if (idx > -1) {
          Object.assign(this.lDailyUpdateAttach.files[idx], curNotes)
        }
        this.beingSaved = false
        this.showNotes = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    PrepareUpdateCat (curFile) {
      this.lCat = Object.assign({}, curFile)
      this.showCats = true
    },
    viewFullImage (url) {
      this.lFullImgUrl = url
      this.showFullImage = true
    },
    async saveCats (curCat) {
      curCat.is_updated_by_sv_user = false
      curCat.is_sub_app = this.lDailyUpdate.is_sub_app ? this.lDailyUpdate.is_sub_app : 0
      curCat.is_app = this.lDailyUpdate.is_app ? this.lDailyUpdate.is_app : 0
      // Case: Photo is already offline/pending in IndexedDB
      if (!this.isOnline || curCat.operation) {
        if (curCat.operation) {
          await DailyUpdateBucket.updatePhoto(curCat)
        }
        if (!this.isOnline && !curCat.operation) {
          // If editing a server photo while offline, we could save it as an offline record
          // but for now, we'll focus on editing existing offline records.
        }
        // update the front end immediately
        var idx = this.lDailyUpdateAttach.files.findIndex(rec => (rec.c_date === curCat.c_date) && (rec.comm_id === curCat.comm_id) && (rec.file_url === curCat.file_url))
        if (idx > -1) {
          Object.assign(this.lDailyUpdateAttach.files[idx], curCat)
        }
        this.loadTimeLine(curCat.c_date)
        this.showCats = false
        if (!this.isOnline) {
          this.msg('Offline! Change saved locally.', 2)
          return
        }
      }
      // command->user intraction Dailyupdate (/daily-update) -> Photos -> Change Category -> (Stay) -> API Route: /facilityDailyUpdateAttach/update
      this.axios.post(config.API_URL + '/facilityDailyUpdateAttach/update', curCat)
      .then(response => {
        // update the front end
        var idx = this.lDailyUpdateAttach.files.findIndex(rec => (rec.c_date === curCat.c_date) && (rec.comm_id === curCat.comm_id) && (rec.file_url === curCat.file_url))
        if (idx > -1) {
          Object.assign(this.lDailyUpdateAttach.files[idx], curCat)
        }
        this.loadTimeLine(curCat.c_date)
        this.showCats = false
      })
      .catch(err => {
        this.msg(err)
      })
    },
    loadCategoryImage (curcategory) {
      if (curcategory) {
        this.lDailyUpdateAttach.files = []
        this.lDailyUpdateAttach.cat = curcategory
        if (curcategory === 'All') {
          this.lDailyUpdateAttach.files = this.lDailyUpdateAttach.fileUrls
        } else if (curcategory === 'Offline') {
          this.lDailyUpdateAttach.files = this.lDailyUpdateAttach.fileUrls.filter(rec => rec.operation)
        } else if (curcategory === 'Online') {
          this.lDailyUpdateAttach.files = this.lDailyUpdateAttach.fileUrls.filter(rec => !rec.operation)
        } else {
          this.lDailyUpdateAttach.files = this.lDailyUpdateAttach.fileUrls.filter(rec => rec.attach_cat_id === curcategory)
        }
        this.$forceUpdate()
      }
    },
    async uploadPhoto (fileUrl) {
      if (!fileUrl) return
      const list = Array.isArray(fileUrl) ? fileUrl : [fileUrl]
      if (list.length === 0) return
      let fallbackCatId = 1
      if (this.photoCatChips && this.photoCatChips.length > 0) {
        fallbackCatId = Number(this.photoCatChips[0].attach_cat_id) || 1
        let briefingChip = this.photoCatChips.find(c => c.attach_cat_name === 'Briefing')
        if (briefingChip && briefingChip.attach_cat_id) {
          fallbackCatId = Number(briefingChip.attach_cat_id) || fallbackCatId
        }
      }
      let finalCatId = fallbackCatId
      if (this.lDailyUpdateAttach.cat && this.lDailyUpdateAttach.cat !== 'All') {
        finalCatId = Number(this.lDailyUpdateAttach.cat) || fallbackCatId
      } else if (this.lDailyUpdateAttach.attach_cat_id && this.lDailyUpdateAttach.attach_cat_id !== 'All') {
        finalCatId = Number(this.lDailyUpdateAttach.attach_cat_id) || fallbackCatId
      }

      // Guaranteed integer protection to prevent ER_BAD_NULL_ERROR and ER_TRUNCATED_WRONG_VALUE
      if (!finalCatId || isNaN(finalCatId)) {
        finalCatId = fallbackCatId
      }
      for (const fileUrl of list) {
        const timestampSlug = (handy.formatDBDateTime(new Date()) + '-' + Math.floor(Math.random() * 1000)).replace(' ', '-').replace(/:/g, '-')
        let newPhoto = {
          c_date: this.lDate,
          comm_id: config.COMM_ID,
          user_id: config.USER_ID,
          user_name: config.CUST_NAME,
          file_name: timestampSlug + '.png',
          file_url: fileUrl,
          attach_cat_id: finalCatId,
          attach_timestamp: new Date(),
          is_updated_by_sv_user: false,
          is_app: this.lDailyUpdate.is_app ? 1 : 0,
          is_sub_app: this.lDailyUpdate.is_sub_app ? 1 : 0,
          bucket_action: 'create',
          id: timestampSlug
        }
        // If offline, save locally
        if (!this.isOnline) {
          try {
            await DailyUpdateBucket.addPhoto({ ...newPhoto, image: fileUrl })
            console.log('Photo saved locally for later sync.')
          } catch (err) {
            this.msg('Error saving photo: ' + err.message, 0)
          }
        } else {
          // Attempt to post online
          try {
            await this.axios.post(config.API_URL + '/facilityDailyUpdateAttach/create', newPhoto)
            console.log('Photo uploaded directly.')
          } catch (err) {
            // Save to IndexedDB on any failure (network error, server error, etc.)
            try {
              await DailyUpdateBucket.addPhoto({ ...newPhoto, image: fileUrl })
              this.msg('Upload failed! Photo saved locally for later sync.', 2)
              console.log('Photo saved locally due to upload failure:', err.message)
            } catch (dbErr) {
              this.msg('Failed to save photo: ' + err.message, 0)
              console.error('Failed to save to IndexedDB:', dbErr)
            }
          }
        }
      }
      // Finish by reloading everything once
      this.msg(list.length > 1 ? `${list.length} photos processed.` : 'Photo processed.', 1)
      setTimeout(() => {
        this.loadFacDailyUpdateAttachment(this.lDate)
        this.loadTimeLine(this.lDate)
      }, 500)
      // })
      // .catch(err => {
      //   this.msg(err.response.data)
      // })
    },
    async deletePhoto (curFile) {
      if (!confirm('Sure, you want to delete the photo?')) {
        return
      }

      if (!this.isOnline && !curFile.operation) {
        alert('Cannot Delete online Image Offline')
        return
      }
      // Case: Photo is already offline/pending in IndexedDB
      if (!this.isOnline || curFile.operation) {
        if (curFile.operation) {
          await DailyUpdateBucket.deletePhoto(curFile.id)
        }
        // update the front end immediately
        var idx = this.lDailyUpdateAttach.fileUrls.findIndex(rec => (rec.c_date === curFile.c_date) && (rec.comm_id === curFile.comm_id) && (rec.file_url === curFile.file_url))
        if (idx > -1) {
          this.lDailyUpdateAttach.fileUrls.splice(idx, 1)
        }
        if (this.lDailyUpdateAttach.cat === 'All') {
          this.lDailyUpdateAttach.files = this.lDailyUpdateAttach.fileUrls
        } else {
          this.lDailyUpdateAttach.files = this.lDailyUpdateAttach.fileUrls.filter(rec => rec.attach_cat_id === this.lDailyUpdateAttach.cat)
        }
        this.$forceUpdate()
        if (!this.isOnline) {
          this.msg('Offline! Photo removed locally.', 1)
          return
        }
      }
      // command->user intraction Dailyupdate (/daily-update) -> Photos -> Delete -> (Stay) -> API Route: /facilityDailyUpdateAttach/delete
      this.axios.post(config.API_URL + '/facilityDailyUpdateAttach/delete', curFile)
      .then(response => {
        // update the front end
        var idx = this.lDailyUpdateAttach.fileUrls.findIndex(rec => (rec.c_date === curFile.c_date) && (rec.comm_id === curFile.comm_id) && (rec.file_url === curFile.file_url))
        if (idx > -1) {
          this.lDailyUpdateAttach.fileUrls.splice(idx, 1)
        }
        if (this.lDailyUpdateAttach.cat === 'All') {
          this.lDailyUpdateAttach.files = this.lDailyUpdateAttach.fileUrls
        } else {
          this.lDailyUpdateAttach.files = this.lDailyUpdateAttach.fileUrls.filter(rec => rec.attach_cat_id === this.lDailyUpdateAttach.cat)
        }
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    compareWithPreviousDay () {
      this.enablePreviousDay = !this.enablePreviousDay
      this.loadDailyAllUpdates(this.lDate)
      this.$forceUpdate()
    },
    loadPhotoCat () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getPhotoCatByCommId/', qry)
      .then(response => {
        this.photoCatChips = response.data
        this.lDailyUpdateAttach.cat = this.photoCatChips[0].attach_cat_id
        this.lDailyUpdateAttach.attach_cat_id = this.lDailyUpdateAttach.cat
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    loadTimeLine (curDate) {
      var qry = {
        params: {
          c_date: curDate,
          comm_id: config.COMM_ID
        }
      }
      this.lTimeLine = {}
      this.axios.get(config.API_URL + '/getTimelineDetailsofDailyReport/', qry)
      .then(response => {
        this.lTimeLine = response.data
      })
      .catch(err => {
        this.msg(err, 0)
        this.lTimeLine = {}
        this.showTimeline = false
      })
    },
    async syncOfflinePhotos () {
      try {
        const offlineItems = await DailyUpdateBucket.getAllPhotos()
        if (!offlineItems || offlineItems.length === 0) return
        console.log(`[Dailyupdate] Background sync starting for ${offlineItems.length} photos...`)
        let successCount = 0
        for (const item of offlineItems) {
          // Prepare payload (cleaning metadata)
          const payload = { ...item }
          delete payload.id
          delete payload.operation
          delete payload.timestamp
          delete payload.type
          // Ensure c_date is in YYYY-MM-DD format for MySQL
          if (payload.c_date) {
            payload.c_date = handy.formatDBDate(new Date(payload.c_date))
          }
          const endpoint = item.operation === 'delete' ? '/facilityDailyUpdateAttach/delete'
            : (item.operation === 'update' ? '/facilityDailyUpdateAttach/update' : '/facilityDailyUpdateAttach/create')
          // Re-map the image Blob to the file_url field for API
          if (item.image) {
            payload.file_url = item.image
            delete payload.image
          }
          try {
            console.log(payload.c_date)
            await this.axios.post(config.API_URL + endpoint, payload)
            await DailyUpdateBucket.deletePhoto(item.id)
            successCount++
          } catch (syncErr) {
            // console.error(`❌ [Dailyupdate] Failed to sync ${item.file_name}:`, syncErr.response ? syncErr.response.data : syncErr.message)
          }
        }
        if (successCount > 0) {
          this.msg(`Background Sync: ${successCount} photos uploaded!`, 1)
          this.loadFacDailyUpdateAttachment(this.lDate)
        }
      } catch (critErr) {
        console.error('[Dailyupdate] Critical sync error:', critErr)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Dailyupdate.vue?6e6c3a73